<template>
  <div
    class="btn-open-detached mdi csst no-shrink"
    @click="openDetached"
    @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
  >
    <i class="mdi mdi-open-in-new"></i>
    <div
      class="csst_content text-nowrap clr-white"
      style="position: fixed"
      v-html="tooltip"
    ></div>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'BtnOpenDetachedTrainerInfo',
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    tooltip: String,
    // page: {default:()=>'detached'},
  },
  data() {
    return {}
  },
  methods: {
    openDetached() {
      localStorage.setItem(
        'study_range_content_hero',
        this.$store.state.solutions.study_range_content_hero,
      )
      localStorage.setItem(
        'study_range_content_opponent',
        this.$store.state.solutions.study_range_content_opponent,
      )

      const query_gameformat = this.$store.getters[`${this.namespace}/query_gameformat`]
      const query_cussol = this.$store.getters[`${this.namespace}/query_cussol`]
      let params = {
        bc_channelname: `${this.namespace}/strategy_channel`,
        ...query_gameformat,
        ...query_cussol,
      }
      params = new URLSearchParams(params)

      const url = `${window.location.origin}/detached-trainer-info?${params}`
      const opts = `
      popup=yes,
      scrollbars=no,
      status=no,
      location=no,
      toolbar=no,
      menubar=no,
      width=1366,
      height=768,
      top=250,
      left=250,`

      window.open(url, '_blank', opts).focus()
    },
  },
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .btn-open-detached {
    display: none;
  }
}
</style>
